export default __webpack_public_path__ + "static/media/bg6.ae42c9a6.jpg";